// @ts-check

if (!customElements.get("ff-facets")) {
  class FfFacets extends FfDrawer {
    ffNewUrl = new URL(window.location.href);

    constructor() {
      super();

      document
        .querySelectorAll("[data-ff-facets-closer]")
        .forEach((elmt) => elmt.addEventListener("click", this.ffClose));

      this.ffRegisterFilterListeners();
    }

    ffRegisterFilterListeners = () => {
      document.querySelectorAll("[data-ff-sortby-value]").forEach(sortby => {
        sortby.addEventListener("click", () => {
  
          this.ffNewUrl.searchParams.set("sort_by", sortby.value);
        });
      })

      /**
       * @type {NodeListOf<HTMLElement>}
       */
      const filters = this.querySelectorAll("[data-ff-filter-value]");
      filters.forEach((filter) => {
        filter.addEventListener("click", () => {
          const { ffFilterValue, ffFilterName } = filter.dataset;

          if (!ffFilterValue || !ffFilterName) {
            throw new Error("Filter is missing name or value in dataset");
          }
          if (this.ffNewUrl.searchParams.has(ffFilterName, ffFilterValue)) {
            this.ffNewUrl.searchParams.delete(ffFilterName, ffFilterValue);
          } else {
            this.ffNewUrl.searchParams.append(ffFilterName, ffFilterValue);
          }
        });
      });

      /**
       * @type {NodeListOf<HTMLInputElement>}
       */
      const priceFilters = this.querySelectorAll("[data-ff-filter-price-name]");
      priceFilters.forEach((priceFilter) => {
        priceFilter.addEventListener("change", () => {
          this.adjustToValidValues(priceFilter);
          this.setMinAndMaxValues(priceFilters);
          const { ffFilterPriceName } = priceFilter.dataset;

          this.ffNewUrl.searchParams.set(ffFilterPriceName, priceFilter.value);
        });

        priceFilter.addEventListener("keydown", (event) => {
          if (event.metaKey) return;

          const pattern =
            /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
          if (!event.key.match(pattern)) event.preventDefault();
        });

        const { ffFilterPriceName } = priceFilter.dataset;

        this.ffNewUrl.searchParams.set(ffFilterPriceName, priceFilter.value);
      });

      this.querySelector("[data-ff-filters-submit]")?.addEventListener(
        "click",
        () => this.ffApplyUrl(this.ffNewUrl)
      );

      this.querySelector("[data-ff-filters-remove]")?.addEventListener(
        "click",
        () => {
          const newUrl = new URL(location.href);
          const actualUrl = new URL(location.href);

          actualUrl.searchParams.forEach((_, index) =>
            index.includes("filter") ? newUrl.searchParams.delete(index) : ""
          );

          this.ffApplyUrl(newUrl);
        }
      );
    };

    /**
     *
     * @param {NodeListOf<HTMLInputElement>} inputs
     */
    setMinAndMaxValues = (inputs) => {
      const minInput = inputs[0];
      const maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
      if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
      if (minInput.value === "") maxInput.setAttribute("data-min", "0");
      if (maxInput.value === "")
        minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
    };

    /**
     *
     * @param {HTMLInputElement} input
     */
    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute("data-min"));
      const max = Number(input.getAttribute("data-max"));

      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }

    /**
     *
     * @param {URL} url
     */
    ffApplyUrl = async (url) => {
      const productGrid = document.getElementById("product-grid");

      url.searchParams.delete(productGrid.dataset.ffPageParam);

      const html = await fetch(url)
        .then((res) => res.text())
        .then((text) => new DOMParser().parseFromString(text, "text/html"));

      productGrid.replaceWith(html.getElementById("product-grid"));

      this.querySelector("[data-ff-drawer-content]").replaceWith(
        html.querySelector("[data-ff-drawer-content]")
      );

      document
        .getElementById("ff-facets-results-count")
        ?.replaceWith(html.getElementById("ff-facets-results-count"));

      history.pushState(url.search, "", url.href);
      this.ffInit(true);
      this.ffRegisterFilterListeners();
    };
  }

  customElements.define("ff-facets", FfFacets);
}
